export default __webpack_public_path__ + "static/media/_ic_light_mode.0e5dfdb5.svg";